import React from 'react'
import { PageContainer } from '@ui'
import { useMe } from '../me.jsx'

export function OrgAdminRoute({ children }) {
  const me = useMe()
  if (!me) return null
  if (!me.isAdmin) {
    return (
      <PageContainer>
        <h1>Access denied</h1>
        <p>You are not an administrator for an organization.</p>
      </PageContainer>
    )
  }
  return children
}
